// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteRouteImport } from './routes/_site/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteAcceptableUseRouteImport } from './routes/_site/acceptable-use'
import { Route as SiteAffiliateTermsRouteImport } from './routes/_site/affiliate-terms'
import { Route as SiteAffiliatesRouteImport } from './routes/_site/affiliates'
import { Route as SiteCatalogRouteImport } from './routes/_site/catalog'
import { Route as SiteContactRouteImport } from './routes/_site/contact'
import { Route as SiteDpaRouteImport } from './routes/_site/dpa'
import { Route as SitePricingRouteImport } from './routes/_site/pricing'
import { Route as SitePrivacyRouteImport } from './routes/_site/privacy'
import { Route as SiteSecurityRouteImport } from './routes/_site/security'
import { Route as SiteSellRouteImport } from './routes/_site/sell'
import { Route as SiteSellerTermsRouteImport } from './routes/_site/seller-terms'
import { Route as SiteTermsRouteImport } from './routes/_site/terms'
import { Route as SiteUsageRouteImport } from './routes/_site/usage'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountBillingRouteImport } from './routes/account/billing'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardAffiliatesRouteImport } from './routes/dashboard/affiliates'
import { Route as DashboardAuditLogRouteImport } from './routes/dashboard/audit-log'
import { Route as DashboardBillingRouteImport } from './routes/dashboard/billing'
import { Route as DashboardCatalogRouteRouteImport } from './routes/dashboard/catalog/route'
import { Route as DashboardConnectRouteImport } from './routes/dashboard/connect'
import { Route as DashboardPlaygroundRouteImport } from './routes/dashboard/playground'
import { Route as DashboardSupportRouteImport } from './routes/dashboard/support'
import { Route as DashboardTeamRouteImport } from './routes/dashboard/team'
import { Route as DashboardUsageRouteImport } from './routes/dashboard/usage'
import { Route as DashboardAuthorizeRouteImport } from './routes/dashboard_.authorize'
import { Route as DashboardJoinRouteImport } from './routes/dashboard_.join'
import { Route as SiteAlternativesIndexRouteImport } from './routes/_site/alternatives/index'
import { Route as SiteAlternativesSlugRouteImport } from './routes/_site/alternatives/$slug'
import { Route as SiteBlogIndexRouteImport } from './routes/_site/blog/index'
import { Route as SiteBlogSlugRouteImport } from './routes/_site/blog/$slug'
import { Route as SiteProvidersIndexRouteImport } from './routes/_site/providers/index'
import { Route as SiteProvidersProviderIdRouteImport } from './routes/_site/providers/$providerId'
import { Route as SiteSellersIndexRouteImport } from './routes/_site/sellers/index'
import { Route as SiteSellersSlugRouteImport } from './routes/_site/sellers/$slug'
import { Route as SiteToolsIndexRouteImport } from './routes/_site/tools/index'
import { Route as SiteToolsAmazonReviewSignalsRouteImport } from './routes/_site/tools/amazon-review-signals'
import { Route as SiteToolsAppReviewAnalyzerRouteImport } from './routes/_site/tools/app-review-analyzer'
import { Route as SiteToolsAskSocialDataRouteImport } from './routes/_site/tools/ask-social-data'
import { Route as SiteToolsBrandMentionCheckerRouteImport } from './routes/_site/tools/brand-mention-checker'
import { Route as SiteToolsCreatorEarningsCalculatorRouteImport } from './routes/_site/tools/creator-earnings-calculator'
import { Route as SiteToolsEngagementRateCalculatorRouteImport } from './routes/_site/tools/engagement-rate-calculator'
import { Route as SiteToolsFacebookAdLibraryRouteImport } from './routes/_site/tools/facebook-ad-library'
import { Route as SiteToolsFacebookAdRemixerRouteImport } from './routes/_site/tools/facebook-ad-remixer'
import { Route as SiteToolsInstagramNonFollowersRouteImport } from './routes/_site/tools/instagram-non-followers'
import { Route as SiteToolsInstagramTranscriptRouteImport } from './routes/_site/tools/instagram-transcript'
import { Route as SiteToolsNaverBlogAnalyticsRouteImport } from './routes/_site/tools/naver-blog-analytics'
import { Route as SiteToolsProfileViewerRouteImport } from './routes/_site/tools/profile-viewer'
import { Route as SiteToolsRedditMarketingRouteImport } from './routes/_site/tools/reddit-marketing'
import { Route as SiteToolsRedditResearchRouteImport } from './routes/_site/tools/reddit-research'
import { Route as SiteToolsRedditSeoFinderRouteImport } from './routes/_site/tools/reddit-seo-finder'
import { Route as SiteToolsSnapchatStoryViewerRouteImport } from './routes/_site/tools/snapchat-story-viewer'
import { Route as SiteToolsSocialTranscriptRouteImport } from './routes/_site/tools/social-transcript'
import { Route as SiteToolsStockComparisonRouteImport } from './routes/_site/tools/stock-comparison'
import { Route as SiteToolsSwitchSignalsRouteImport } from './routes/_site/tools/switch-signals'
import { Route as SiteToolsTiktokAudienceAnalyzerRouteImport } from './routes/_site/tools/tiktok-audience-analyzer'
import { Route as SiteToolsTiktokTranscriptRouteImport } from './routes/_site/tools/tiktok-transcript'
import { Route as SiteToolsTwitchEarningsCalculatorRouteImport } from './routes/_site/tools/twitch-earnings-calculator'
import { Route as SiteToolsUsernameCheckerRouteImport } from './routes/_site/tools/username-checker'
import { Route as SiteToolsXNonFollowersRouteImport } from './routes/_site/tools/x-non-followers'
import { Route as SiteToolsYoutubeChannelTranscriptsRouteImport } from './routes/_site/tools/youtube-channel-transcripts'
import { Route as SiteToolsYoutubeCommentAnalyzerRouteImport } from './routes/_site/tools/youtube-comment-analyzer'
import { Route as SiteToolsYoutubeShortsEarningsRouteImport } from './routes/_site/tools/youtube-shorts-earnings'
import { Route as SiteToolsYoutubeTranscriptRouteImport } from './routes/_site/tools/youtube-transcript'
import { Route as DashboardAgentIndexRouteImport } from './routes/dashboard/agent/index'
import { Route as DashboardAgentThreadIdRouteImport } from './routes/dashboard/agent/$threadId'
import { Route as DashboardCatalogIndexRouteImport } from './routes/dashboard/catalog/index'
import { Route as DashboardKeysIndexRouteImport } from './routes/dashboard/keys.index'
import { Route as DashboardKeysKeyIdRouteImport } from './routes/dashboard/keys.$keyId'
import { Route as DashboardSellIndexRouteImport } from './routes/dashboard/sell.index'
import { Route as DashboardSellEarningsRouteImport } from './routes/dashboard/sell.earnings'
import { Route as SiteApiApiIdIndexRouteImport } from './routes/_site/api/$apiId/index'
import { Route as SiteApiApiIdEndpointIdRouteImport } from './routes/_site/api/$apiId/$endpointId'
import { Route as SiteBlogAuthorIdRouteImport } from './routes/_site/blog/author.$id'
import { Route as DashboardCatalogApiIdIndexRouteImport } from './routes/dashboard/catalog/$apiId/index'
import { Route as DashboardCatalogApiIdEndpointIdRouteImport } from './routes/dashboard/catalog/$apiId/$endpointId'
import { Route as DashboardSellEndpointsIndexRouteImport } from './routes/dashboard/sell.endpoints.index'
import { Route as DashboardSellEndpointsEndpointIdRouteImport } from './routes/dashboard/sell.endpoints.$endpointId'

const SiteRouteRoute = SiteRouteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRouteRoute
          })
const SiteAboutRoute = SiteAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => SiteRouteRoute
          })
const SiteAcceptableUseRoute = SiteAcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => SiteRouteRoute
          })
const SiteAffiliateTermsRoute = SiteAffiliateTermsRouteImport.update({
            id: '/affiliate-terms',path: '/affiliate-terms',getParentRoute: () => SiteRouteRoute
          })
const SiteAffiliatesRoute = SiteAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => SiteRouteRoute
          })
const SiteCatalogRoute = SiteCatalogRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => SiteRouteRoute
          })
const SiteContactRoute = SiteContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => SiteRouteRoute
          })
const SiteDpaRoute = SiteDpaRouteImport.update({
            id: '/dpa',path: '/dpa',getParentRoute: () => SiteRouteRoute
          })
const SitePricingRoute = SitePricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => SiteRouteRoute
          })
const SitePrivacyRoute = SitePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => SiteRouteRoute
          })
const SiteSecurityRoute = SiteSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => SiteRouteRoute
          })
const SiteSellRoute = SiteSellRouteImport.update({
            id: '/sell',path: '/sell',getParentRoute: () => SiteRouteRoute
          })
const SiteSellerTermsRoute = SiteSellerTermsRouteImport.update({
            id: '/seller-terms',path: '/seller-terms',getParentRoute: () => SiteRouteRoute
          })
const SiteTermsRoute = SiteTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => SiteRouteRoute
          })
const SiteUsageRoute = SiteUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => SiteRouteRoute
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const AccountBillingRoute = AccountBillingRouteImport.update({
            id: '/account/billing',path: '/account/billing',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAffiliatesRoute = DashboardAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAuditLogRoute = DashboardAuditLogRouteImport.update({
            id: '/audit-log',path: '/audit-log',getParentRoute: () => DashboardRouteRoute
          })
const DashboardBillingRoute = DashboardBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCatalogRouteRoute = DashboardCatalogRouteRouteImport.update({
            id: '/catalog',path: '/catalog',getParentRoute: () => DashboardRouteRoute
          })
const DashboardConnectRoute = DashboardConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => DashboardRouteRoute
          })
const DashboardPlaygroundRoute = DashboardPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSupportRoute = DashboardSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => DashboardRouteRoute
          })
const DashboardTeamRoute = DashboardTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => DashboardRouteRoute
          })
const DashboardUsageRoute = DashboardUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAuthorizeRoute = DashboardAuthorizeRouteImport.update({
            id: '/dashboard_/authorize',path: '/dashboard/authorize',getParentRoute: () => rootRouteImport
          })
const DashboardJoinRoute = DashboardJoinRouteImport.update({
            id: '/dashboard_/join',path: '/dashboard/join',getParentRoute: () => rootRouteImport
          })
const SiteAlternativesIndexRoute = SiteAlternativesIndexRouteImport.update({
            id: '/alternatives/',path: '/alternatives/',getParentRoute: () => SiteRouteRoute
          })
const SiteAlternativesSlugRoute = SiteAlternativesSlugRouteImport.update({
            id: '/alternatives/$slug',path: '/alternatives/$slug',getParentRoute: () => SiteRouteRoute
          })
const SiteBlogIndexRoute = SiteBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => SiteRouteRoute
          })
const SiteBlogSlugRoute = SiteBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => SiteRouteRoute
          })
const SiteProvidersIndexRoute = SiteProvidersIndexRouteImport.update({
            id: '/providers/',path: '/providers/',getParentRoute: () => SiteRouteRoute
          })
const SiteProvidersProviderIdRoute = SiteProvidersProviderIdRouteImport.update({
            id: '/providers/$providerId',path: '/providers/$providerId',getParentRoute: () => SiteRouteRoute
          })
const SiteSellersIndexRoute = SiteSellersIndexRouteImport.update({
            id: '/sellers/',path: '/sellers/',getParentRoute: () => SiteRouteRoute
          })
const SiteSellersSlugRoute = SiteSellersSlugRouteImport.update({
            id: '/sellers/$slug',path: '/sellers/$slug',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsIndexRoute = SiteToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsAmazonReviewSignalsRoute = SiteToolsAmazonReviewSignalsRouteImport.update({
            id: '/tools/amazon-review-signals',path: '/tools/amazon-review-signals',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsAppReviewAnalyzerRoute = SiteToolsAppReviewAnalyzerRouteImport.update({
            id: '/tools/app-review-analyzer',path: '/tools/app-review-analyzer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsAskSocialDataRoute = SiteToolsAskSocialDataRouteImport.update({
            id: '/tools/ask-social-data',path: '/tools/ask-social-data',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsBrandMentionCheckerRoute = SiteToolsBrandMentionCheckerRouteImport.update({
            id: '/tools/brand-mention-checker',path: '/tools/brand-mention-checker',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsCreatorEarningsCalculatorRoute = SiteToolsCreatorEarningsCalculatorRouteImport.update({
            id: '/tools/creator-earnings-calculator',path: '/tools/creator-earnings-calculator',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsEngagementRateCalculatorRoute = SiteToolsEngagementRateCalculatorRouteImport.update({
            id: '/tools/engagement-rate-calculator',path: '/tools/engagement-rate-calculator',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsFacebookAdLibraryRoute = SiteToolsFacebookAdLibraryRouteImport.update({
            id: '/tools/facebook-ad-library',path: '/tools/facebook-ad-library',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsFacebookAdRemixerRoute = SiteToolsFacebookAdRemixerRouteImport.update({
            id: '/tools/facebook-ad-remixer',path: '/tools/facebook-ad-remixer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsInstagramNonFollowersRoute = SiteToolsInstagramNonFollowersRouteImport.update({
            id: '/tools/instagram-non-followers',path: '/tools/instagram-non-followers',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsInstagramTranscriptRoute = SiteToolsInstagramTranscriptRouteImport.update({
            id: '/tools/instagram-transcript',path: '/tools/instagram-transcript',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsNaverBlogAnalyticsRoute = SiteToolsNaverBlogAnalyticsRouteImport.update({
            id: '/tools/naver-blog-analytics',path: '/tools/naver-blog-analytics',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsProfileViewerRoute = SiteToolsProfileViewerRouteImport.update({
            id: '/tools/profile-viewer',path: '/tools/profile-viewer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsRedditMarketingRoute = SiteToolsRedditMarketingRouteImport.update({
            id: '/tools/reddit-marketing',path: '/tools/reddit-marketing',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsRedditResearchRoute = SiteToolsRedditResearchRouteImport.update({
            id: '/tools/reddit-research',path: '/tools/reddit-research',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsRedditSeoFinderRoute = SiteToolsRedditSeoFinderRouteImport.update({
            id: '/tools/reddit-seo-finder',path: '/tools/reddit-seo-finder',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsSnapchatStoryViewerRoute = SiteToolsSnapchatStoryViewerRouteImport.update({
            id: '/tools/snapchat-story-viewer',path: '/tools/snapchat-story-viewer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsSocialTranscriptRoute = SiteToolsSocialTranscriptRouteImport.update({
            id: '/tools/social-transcript',path: '/tools/social-transcript',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsStockComparisonRoute = SiteToolsStockComparisonRouteImport.update({
            id: '/tools/stock-comparison',path: '/tools/stock-comparison',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsSwitchSignalsRoute = SiteToolsSwitchSignalsRouteImport.update({
            id: '/tools/switch-signals',path: '/tools/switch-signals',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsTiktokAudienceAnalyzerRoute = SiteToolsTiktokAudienceAnalyzerRouteImport.update({
            id: '/tools/tiktok-audience-analyzer',path: '/tools/tiktok-audience-analyzer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsTiktokTranscriptRoute = SiteToolsTiktokTranscriptRouteImport.update({
            id: '/tools/tiktok-transcript',path: '/tools/tiktok-transcript',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsTwitchEarningsCalculatorRoute = SiteToolsTwitchEarningsCalculatorRouteImport.update({
            id: '/tools/twitch-earnings-calculator',path: '/tools/twitch-earnings-calculator',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsUsernameCheckerRoute = SiteToolsUsernameCheckerRouteImport.update({
            id: '/tools/username-checker',path: '/tools/username-checker',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsXNonFollowersRoute = SiteToolsXNonFollowersRouteImport.update({
            id: '/tools/x-non-followers',path: '/tools/x-non-followers',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsYoutubeChannelTranscriptsRoute = SiteToolsYoutubeChannelTranscriptsRouteImport.update({
            id: '/tools/youtube-channel-transcripts',path: '/tools/youtube-channel-transcripts',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsYoutubeCommentAnalyzerRoute = SiteToolsYoutubeCommentAnalyzerRouteImport.update({
            id: '/tools/youtube-comment-analyzer',path: '/tools/youtube-comment-analyzer',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsYoutubeShortsEarningsRoute = SiteToolsYoutubeShortsEarningsRouteImport.update({
            id: '/tools/youtube-shorts-earnings',path: '/tools/youtube-shorts-earnings',getParentRoute: () => SiteRouteRoute
          })
const SiteToolsYoutubeTranscriptRoute = SiteToolsYoutubeTranscriptRouteImport.update({
            id: '/tools/youtube-transcript',path: '/tools/youtube-transcript',getParentRoute: () => SiteRouteRoute
          })
const DashboardAgentIndexRoute = DashboardAgentIndexRouteImport.update({
            id: '/agent/',path: '/agent/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAgentThreadIdRoute = DashboardAgentThreadIdRouteImport.update({
            id: '/agent/$threadId',path: '/agent/$threadId',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCatalogIndexRoute = DashboardCatalogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogRouteRoute
          })
const DashboardKeysIndexRoute = DashboardKeysIndexRouteImport.update({
            id: '/keys/',path: '/keys/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardKeysKeyIdRoute = DashboardKeysKeyIdRouteImport.update({
            id: '/keys/$keyId',path: '/keys/$keyId',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSellIndexRoute = DashboardSellIndexRouteImport.update({
            id: '/sell/',path: '/sell/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSellEarningsRoute = DashboardSellEarningsRouteImport.update({
            id: '/sell/earnings',path: '/sell/earnings',getParentRoute: () => DashboardRouteRoute
          })
const SiteApiApiIdIndexRoute = SiteApiApiIdIndexRouteImport.update({
            id: '/api/$apiId/',path: '/api/$apiId/',getParentRoute: () => SiteRouteRoute
          })
const SiteApiApiIdEndpointIdRoute = SiteApiApiIdEndpointIdRouteImport.update({
            id: '/api/$apiId/$endpointId',path: '/api/$apiId/$endpointId',getParentRoute: () => SiteRouteRoute
          })
const SiteBlogAuthorIdRoute = SiteBlogAuthorIdRouteImport.update({
            id: '/blog/author/$id',path: '/blog/author/$id',getParentRoute: () => SiteRouteRoute
          })
const DashboardCatalogApiIdIndexRoute = DashboardCatalogApiIdIndexRouteImport.update({
            id: '/$apiId/',path: '/$apiId/',getParentRoute: () => DashboardCatalogRouteRoute
          })
const DashboardCatalogApiIdEndpointIdRoute = DashboardCatalogApiIdEndpointIdRouteImport.update({
            id: '/$apiId/$endpointId',path: '/$apiId/$endpointId',getParentRoute: () => DashboardCatalogRouteRoute
          })
const DashboardSellEndpointsIndexRoute = DashboardSellEndpointsIndexRouteImport.update({
            id: '/sell/endpoints/',path: '/sell/endpoints/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSellEndpointsEndpointIdRoute = DashboardSellEndpointsEndpointIdRouteImport.update({
            id: '/sell/endpoints/$endpointId',path: '/sell/endpoints/$endpointId',getParentRoute: () => DashboardRouteRoute
          })





const SiteRouteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,SiteAcceptableUseRoute: SiteAcceptableUseRoute,SiteAffiliateTermsRoute: SiteAffiliateTermsRoute,SiteAffiliatesRoute: SiteAffiliatesRoute,SiteCatalogRoute: SiteCatalogRoute,SiteContactRoute: SiteContactRoute,SiteDpaRoute: SiteDpaRoute,SitePricingRoute: SitePricingRoute,SitePrivacyRoute: SitePrivacyRoute,SiteSecurityRoute: SiteSecurityRoute,SiteSellRoute: SiteSellRoute,SiteSellerTermsRoute: SiteSellerTermsRoute,SiteTermsRoute: SiteTermsRoute,SiteUsageRoute: SiteUsageRoute,SiteIndexRoute: SiteIndexRoute,SiteAlternativesSlugRoute: SiteAlternativesSlugRoute,SiteBlogSlugRoute: SiteBlogSlugRoute,SiteProvidersProviderIdRoute: SiteProvidersProviderIdRoute,SiteSellersSlugRoute: SiteSellersSlugRoute,SiteToolsAmazonReviewSignalsRoute: SiteToolsAmazonReviewSignalsRoute,SiteToolsAppReviewAnalyzerRoute: SiteToolsAppReviewAnalyzerRoute,SiteToolsAskSocialDataRoute: SiteToolsAskSocialDataRoute,SiteToolsBrandMentionCheckerRoute: SiteToolsBrandMentionCheckerRoute,SiteToolsCreatorEarningsCalculatorRoute: SiteToolsCreatorEarningsCalculatorRoute,SiteToolsEngagementRateCalculatorRoute: SiteToolsEngagementRateCalculatorRoute,SiteToolsFacebookAdLibraryRoute: SiteToolsFacebookAdLibraryRoute,SiteToolsFacebookAdRemixerRoute: SiteToolsFacebookAdRemixerRoute,SiteToolsInstagramNonFollowersRoute: SiteToolsInstagramNonFollowersRoute,SiteToolsInstagramTranscriptRoute: SiteToolsInstagramTranscriptRoute,SiteToolsNaverBlogAnalyticsRoute: SiteToolsNaverBlogAnalyticsRoute,SiteToolsProfileViewerRoute: SiteToolsProfileViewerRoute,SiteToolsRedditMarketingRoute: SiteToolsRedditMarketingRoute,SiteToolsRedditResearchRoute: SiteToolsRedditResearchRoute,SiteToolsRedditSeoFinderRoute: SiteToolsRedditSeoFinderRoute,SiteToolsSnapchatStoryViewerRoute: SiteToolsSnapchatStoryViewerRoute,SiteToolsSocialTranscriptRoute: SiteToolsSocialTranscriptRoute,SiteToolsStockComparisonRoute: SiteToolsStockComparisonRoute,SiteToolsSwitchSignalsRoute: SiteToolsSwitchSignalsRoute,SiteToolsTiktokAudienceAnalyzerRoute: SiteToolsTiktokAudienceAnalyzerRoute,SiteToolsTiktokTranscriptRoute: SiteToolsTiktokTranscriptRoute,SiteToolsTwitchEarningsCalculatorRoute: SiteToolsTwitchEarningsCalculatorRoute,SiteToolsUsernameCheckerRoute: SiteToolsUsernameCheckerRoute,SiteToolsXNonFollowersRoute: SiteToolsXNonFollowersRoute,SiteToolsYoutubeChannelTranscriptsRoute: SiteToolsYoutubeChannelTranscriptsRoute,SiteToolsYoutubeCommentAnalyzerRoute: SiteToolsYoutubeCommentAnalyzerRoute,SiteToolsYoutubeShortsEarningsRoute: SiteToolsYoutubeShortsEarningsRoute,SiteToolsYoutubeTranscriptRoute: SiteToolsYoutubeTranscriptRoute,SiteAlternativesIndexRoute: SiteAlternativesIndexRoute,SiteBlogIndexRoute: SiteBlogIndexRoute,SiteProvidersIndexRoute: SiteProvidersIndexRoute,SiteSellersIndexRoute: SiteSellersIndexRoute,SiteToolsIndexRoute: SiteToolsIndexRoute,SiteApiApiIdEndpointIdRoute: SiteApiApiIdEndpointIdRoute,SiteBlogAuthorIdRoute: SiteBlogAuthorIdRoute,SiteApiApiIdIndexRoute: SiteApiApiIdIndexRoute
}

const SiteRouteRouteWithChildren = SiteRouteRoute._addFileChildren(SiteRouteRouteChildren)




const DashboardCatalogRouteRouteChildren = {
  DashboardCatalogIndexRoute: DashboardCatalogIndexRoute,DashboardCatalogApiIdEndpointIdRoute: DashboardCatalogApiIdEndpointIdRoute,DashboardCatalogApiIdIndexRoute: DashboardCatalogApiIdIndexRoute
}

const DashboardCatalogRouteRouteWithChildren = DashboardCatalogRouteRoute._addFileChildren(DashboardCatalogRouteRouteChildren)



const DashboardRouteRouteChildren = {
  DashboardCatalogRouteRoute: DashboardCatalogRouteRouteWithChildren,DashboardAffiliatesRoute: DashboardAffiliatesRoute,DashboardAuditLogRoute: DashboardAuditLogRoute,DashboardBillingRoute: DashboardBillingRoute,DashboardConnectRoute: DashboardConnectRoute,DashboardPlaygroundRoute: DashboardPlaygroundRoute,DashboardSupportRoute: DashboardSupportRoute,DashboardTeamRoute: DashboardTeamRoute,DashboardUsageRoute: DashboardUsageRoute,DashboardIndexRoute: DashboardIndexRoute,DashboardAgentThreadIdRoute: DashboardAgentThreadIdRoute,DashboardKeysKeyIdRoute: DashboardKeysKeyIdRoute,DashboardSellEarningsRoute: DashboardSellEarningsRoute,DashboardAgentIndexRoute: DashboardAgentIndexRoute,DashboardKeysIndexRoute: DashboardKeysIndexRoute,DashboardSellIndexRoute: DashboardSellIndexRoute,DashboardSellEndpointsEndpointIdRoute: DashboardSellEndpointsEndpointIdRoute,DashboardSellEndpointsIndexRoute: DashboardSellEndpointsIndexRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)

const rootRouteChildren = {
  SiteRouteRoute: SiteRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,WelcomeRoute: WelcomeRoute,AccountBillingRoute: AccountBillingRoute,DashboardAuthorizeRoute: DashboardAuthorizeRoute,DashboardJoinRoute: DashboardJoinRoute,AccountIndexRoute: AccountIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)